import { useRef } from "react";
import styled from "styled-components";
import backgound_image from "../images/background2.jpg";
import backgound_image_mobile from "../images/background2_mobile.jpg";
import FlexArrow from "../components/FlexArrow";
import { AndroidLogo, Rhombus, WindowsLogo } from "../components/svgs";
import { download_file } from "../api/api";
import contents from '../utills/page_contents.json'

const Container = styled.div<{ img: string; mobile_img: string }>`
  min-height: 100vh;
  max-height: fit-content;
  background-image: url(${(props) => props.img});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    min-height: 800px;
    background-image: url(${(props) => props.mobile_img});
  }
`;

const Main = styled.div`
  width: 90%;
  min-height: max-content; //여기 나중에 손볼 곳.
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
  position: relative;
  padding-top: 40px;
  top: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    top: 80px;
  }
`;

const Section = styled.section`
  margin: 50px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;
`;

const PlatformTitle = styled.h1`
  font-weight: 600;
`;

const DownLoadBtn = styled.a`
  width: 366px;
  height: 95px;
  border: solid 1px ${(props) => props.theme.textColor_base};
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 1s;
  & h1 {
    font-size: 0.8rem;
    font-weight: 600;
  }
  & span {
    font-size: 0.6rem;
  }
  & span span{
    text-transform: lowercase;
  }
  @media (max-width: 1024px) {
    width: 312px;
    height: 84px;
  }
  @media (max-width: 768px) {
    width: 270px;
    height: 72px;
  }
  @media (max-width: 400px) {
    width: 250px;
    height: 62px;
  }
`;

const History = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  padding: 20px 0px;
  text-align: center;
  & svg {
    margin-bottom: 20px;
  }
  & h1 {
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 20px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: ${(props) => props.theme.textColor_base};
      height: 1px;
      width: 100%;
    }
  }
  & span {
    font-size: 0.73rem;
  }
`;

function DownLoad() {
  const ref = useRef<HTMLDivElement>(null);

  const {platform_types, download_texts} = contents

  const onHistoryClick = () => {
    alert("We will update/upload historys");
  };

  return (
    <Container
      img={backgound_image}
      mobile_img={backgound_image_mobile}
      id="download"
      ref={ref}
      className="page-container"
    >
      <FlexArrow next_page="price" />
      <Main>
        {platform_types.map((platform_type) => (
          <Section key={platform_type.OS}>
            <PlatformTitle>{platform_type.OS}</PlatformTitle>
            {platform_type.OS === 'Windows' ? <WindowsLogo/> : <AndroidLogo/>}
            <DownLoadBtn
              onClick={() =>
                download_file(
                  `${platform_type.device}Ols`,
                  `${platform_type.device}Ols`
                )
              }
            >
              <h1>Download</h1>
              <span>{`${platform_type.device}${download_texts.first}`}</span>
            </DownLoadBtn>
            <DownLoadBtn
              onClick={() =>
                download_file(
                  `${platform_type.device}Content`,
                  `${platform_type.device}_BLEPlayer`
                )
              }
            >
              <h1>Download</h1>
              <span>{`${download_texts.second}`}<span>{`${platform_type.device}`}</span></span>
            </DownLoadBtn>
          </Section>
        ))}
      </Main>
      <History>
        <Rhombus />
        <h1 onClick={onHistoryClick}>Update History</h1>
        <span>* You can check BLE Player update history</span>
      </History>
    </Container>
  );
}

export default DownLoad;
